export const getShowDialog = store => store.rfps.showDialog
export const getShowErrors = store => store.rfps.showErrors
export const getRfpData = store => store.rfps.rfpData
